<template>
  <router-view />
  <VersionCheck />
  <EnvironmentBadge />
</template>

<script setup lang="ts">
import VersionCheck from '@/components/VersionCheck.vue';
import EnvironmentBadge from '@/components/EnvironmentBadge.vue';
</script>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
